import { AppRoutePaths } from '~/common/models/route.model';

export const getDefaultProfileMenu = () => [
  {
    label: 'common:header.signOut',
    testId: 'logout-menu',
    onClick: { redirect: AppRoutePaths.LOGOUT },
    section: 'bottom',
  },
];
